module.exports = __webpack_public_path__ + "static/media/ladybug_logo.5fb6365c.png";